import "./Match.css";

export default function MatchCard({ match }) {
  return (
    <div className="match-card">
      {/* User image */}
      <img
        src={
          match.profilePicture
            ? match.profilePicture
            : "https://via.placeholder.com/80"
        }
        alt="Profile"
        className="match-image"
      />

      {/* Info */}
      <div className="match-info">
        <h3 className="match-name">
          {match.firstName} {match.lastName}
        </h3>

        <p className="match-detail">
          Age: {match.age} • Height: {match.height} cm
        </p>

        <p className="match-detail">
          Location: {match.location?.city}, {match.location?.state}
        </p>

        <p className="match-detail">
          Religion: {match.religion} • Caste: {match.caste}
        </p>
      </div>
    </div>
  );
}
